import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, NavX, ReqX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XScroll, XText } from "IZOX/_X";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PDCPolicy extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      count: {
        Total: 0,
        Pending: 0,
        Active: 0,
        ExpirySoon: 0,
        Expired: 0,
        Renewed: 0,
        Canceled: 0
      }
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetCount();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCPolicy.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (tab) => {
    let {history} = this.props;
    NavX.Goto(history, `/DCustomer/AllPolicies?status=${tab}`, false, true);
  }

  GetCount = async () => {
    let res = await ReqX.SendBE("/Web/DCustomer/CountPolicies");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        count: payload
      });
    }
  }

  renderBox(count, desc, color, bgColor, funcName){
    return (
      <XButton color={color} bgColor={bgColor} 
        style={{boxShadow: `0px 1px 2px 2px ${ColorX.CSS("lightGrey", 0.5)}`}}
        width={105} height={88}
        onPress={() => this._toPage(funcName)}>
        <XText bold fontSize={16}>
          {count}
        </XText>
        <XText fontSize={14}>
          {LocaleX.Parse(desc)}
        </XText>
      </XButton>
    );
  }

  renderBoxM(count, desc, color, bgColor, funcName){
      return (
        <XButton color={color} bgColor={bgColor} alignSelf="stretch"
          style={{boxShadow: `0px 1px 2px 2px ${ColorX.CSS("lightGrey", 0.5)}`}}
          width={85} mR={10} pV={5} round={8}
          onPress={() => this._toPage(funcName)}>
          <VStack fullWidth HAlign="|">
            <HStack HAlign="|">
              <XText bold fontSize={14} textAlign="|">
                {count}
              </XText>
            </HStack>
            <HStack HAlign="|">
              <XText fontSize={12} textAlign="|">
                {LocaleX.Parse(desc)}
              </XText>
            </HStack>
          </VStack>
        </XButton>
      );
    }

  renderNormal(){
    let {count} = this.state;
    let {Total, Pending, Active, ExpirySoon, Expired, Renewed, Canceled} = count ?? {};
    return (
      <VStack width={157} bgColor={ColorX.CSS("pureWhite")} pV={16} mT={20}
        spacing={16} fullHeight>
        <HStack>
          <XText color={ColorX.CSS("Leaf")} fontSize={14} bold>
            {LocaleX.Parse({
              EN: `Policies overview (${Total})`,
              TC: `保單概覽 (${Total})`
            })}
          </XText>
        </HStack>
        {this.renderBox(Pending, 
          {
            EN: "Pending",
            TC: "處理中"
          }, ColorX.CSS("Pending"), ColorX.CSS("PendingBg"), "Pending")}
        {this.renderBox(Active, 
          {
            EN: "Active",
            TC: "生效中"
          }, ColorX.CSS("Active"), ColorX.CSS("ActiveBg"), "Active")}
        {this.renderBox(ExpirySoon, 
          {
            EN: "Expiry Soon",
            TC: "即將過期"
          }, ColorX.CSS("ExpireSoon"), ColorX.CSS("ExpireSoonBg"), "ExpirySoon")}
        {this.renderBox(Expired, 
          {
            EN: "Expired",
            TC: "已過期"
          }, ColorX.CSS("Expired"), ColorX.CSS("ExpiredBg"), "Expired")}
        {this.renderBox(Renewed, 
          {
            EN: "Renewed",
            TC: "已更新"
          }, ColorX.CSS("Renewed"), ColorX.CSS("RenewedBg"), "Renewed")}
        {this.renderBox(Canceled, 
          {
            EN: "Canceled",
            TC: "已取消"
          }, ColorX.CSS("Canceled"), ColorX.CSS("CanceledBg"), "Canceled")}
      </VStack>
    );
  }

  renderMobile(){
    let {count} = this.state;
    let {Total, Pending, Active, ExpirySoon, Expired, Renewed, Canceled} = count ?? {};
    return (
      <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pH={8} pV={4} VAlign="^">
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Leaf")} fontSize={14} bold>
            {LocaleX.Parse({
              EN: `Policies overview (${Total})`,
              TC: `保單概覽 (${Total})`
            })}
          </XText>
        </HStack>
        <XScroll fullWidth>
          <HStack fitWidthToContent pB={8} pV={5}>
            {this.renderBoxM(Pending, 
              {
                EN: "Pending",
                TC: "處理中"
              }, ColorX.CSS("Pending"), ColorX.CSS("PendingBg"), "Pending")}
            {this.renderBoxM(Active, 
              {
                EN: "Active",
                TC: "生效中"
              }, ColorX.CSS("Active"), ColorX.CSS("ActiveBg"), "Active")}
            {this.renderBoxM(ExpirySoon, 
              {
                EN: "Expiry Soon",
                TC: "即將過期"
              }, ColorX.CSS("ExpireSoon"), ColorX.CSS("ExpireSoonBg"), "ExpirySoon")}
            {this.renderBoxM(Expired, 
              {
                EN: "Expired",
                TC: "已過期"
              }, ColorX.CSS("Expired"), ColorX.CSS("ExpiredBg"), "Expired")}
            {this.renderBoxM(Renewed, 
              {
                EN: "Renewed",
                TC: "已更新"
              }, ColorX.CSS("Renewed"), ColorX.CSS("RenewedBg"), "Renewed")}
            {this.renderBoxM(Canceled, 
              {
                EN: "Canceled",
                TC: "已取消"
              }, ColorX.CSS("Canceled"), ColorX.CSS("CanceledBg"), "Canceled")}
          </HStack>
        </XScroll>
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }

}

export default withRouter(observer(PDCPolicy));
